import React, { FC } from 'react';
import { StandaloneTabsProps, TabsProps } from './Tabs.types';
import Tabs from './Tabs';

export const dummyAemTabProps = {
  accessibilityLabel: '',
  allowedComponents: { applicable: true, components: [] },
  cqPath: '',
  isInEditor: false,
  title: '',
};

const WithDummyAemProps = (Comp: FC<TabsProps>) => (props: StandaloneTabsProps) =>
  <Comp {...dummyAemTabProps} {...props} />;

export default WithDummyAemProps(Tabs);
